module.exports = __webpack_public_path__ + "img/frame_medium_mid.fbb4edb5.svg";